import * as api from '@pointOfSale/api';
import * as MutationTypes from '../mutationTypes';
import { Menu } from '../models';

export const menuListRequest = async ({ commit }, pointOfSaleGuid) => {
  const response = await api.menuListRequest(pointOfSaleGuid);
  const menusList = Menu.toInstanceList(response.data);
  commit(MutationTypes.MENU_LIST_SUCCESS, menusList);
  return menusList;
};

export const createMenuRequest = async ({ commit }, menu) => {
  const response = await api.createMenuRequest(menu.getFormData());
  const newMenu = Menu.toInstance(response.data);
  commit(MutationTypes.CREATE_MENU_SUCCESS, newMenu);
  return newMenu;
};

export const editMenuRequest = async ({ commit }, menu) => {
  const response = await api.editMenuRequest(menu.guid, menu.getFormData());
  const editedMenu = Menu.toInstance(response.data);
  commit(MutationTypes.EDIT_MENU_SUCCESS, editedMenu);
  return menu;
};

export const publishMenuRequest = async ({ commit }, menuGuid) => {
  const response = await api.publishMenuRequest(menuGuid);
  return response.data.publication_guid;
};

export const deleteMenuRequest = async ({ commit }, menu) => {
  await api.deleteMenuRequest(menu.guid);
  commit(MutationTypes.DELETE_MENU_SUCCESS, menu);
  return menu;
};

export const updateMenuPublication = ({ commit }, { menuGuid, updatedPublication }) => {
  commit(MutationTypes.UPDATE_MENU_PUBLICATION, { menuGuid, updatedPublication });
};
